module.exports = __webpack_public_path__ + "media/images/moscow-1cb03480.jpg";